import { Header, Personalize } from '@/components';

import { MainWrapper } from '@/styles/global.elements';

const PersonalizeView = () => {
  return (
    <MainWrapper $light $dark>
      <Header light />
      <Personalize />
    </MainWrapper>
  );
};

export default PersonalizeView;
